import { useEffect, useState } from "react";

/**
 * Mobil (dar ekran) tespiti — inline-style iki-kolon düzenleri CSS media
 * query ile ezilemediği için JS tarafında karar veriyoruz. Eşik App.css'teki
 * mobil breakpoint (768px) ile aynı tutulmalı.
 */
export function useIsMobile(breakpoint = 768) {
  const q = `(max-width: ${breakpoint}px)`;
  const [mobil, setMobil] = useState(
    typeof window !== "undefined" ? window.matchMedia(q).matches : false
  );
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = (e) => setMobil(e.matches);
    setMobil(mq.matches);
    // Safari eski sürüm: addListener/removeListener fallback
    if (mq.addEventListener) mq.addEventListener("change", on);
    else mq.addListener(on);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", on);
      else mq.removeListener(on);
    };
  }, [q]);
  return mobil;
}
